module.exports = __webpack_public_path__ + "static/website-badge-195982a390d73fba970f20d84372ee52.svg";